import { create as createAxiosClient } from 'axios';

import { config } from '../config/env.config';

/**
 * Axios client for the Quality Formulas/Templates features, backed by the same Contract Entry
 * API as `api.ts`. Kept separate (rather than merged into `api.ts`'s client) so the ported
 * `templatesApi.ts`/`pricingEngineApi.ts` modules — brought over from the Pricing Engine
 * reference app as-is — need no changes beyond this import.
 *
 * Unlike the reference app's `apiClient.ts`, this never attaches an Authorization header: the
 * Contract Entry API Gateway has no authorizer configured (see `services/api/cdk/lib/AppStack.ts`)
 * — access is already gated upstream by `AuthGate`/Cognito, not per-request tokens here.
 */
export const apiClient = createAxiosClient({
  baseURL: config.api.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});
